import React from "react";
import { Toast } from "react-bootstrap";
import ReactDOM from "react-dom";

const ToastNotification = ({ show, message, onClose, delay = 3000 }) => {
  return ReactDOM.createPortal(
    <Toast
      onClose={onClose}
      show={show}
      delay={delay}
      autohide
      className="bg-success text-white shadow-lg"
      style={{
        position: "fixed",
        bottom: "1rem",
        right: "1rem",
        zIndex: 9999,
      }}
    >
      <Toast.Body>{message}</Toast.Body>
    </Toast>,
    document.getElementById("toast-root")
  );
};

export default ToastNotification;
